import { render, staticRenderFns } from "./collect-crowd.vue?vue&type=template&id=35fca353"
import script from "./collect-crowd.vue?vue&type=script&lang=js"
export * from "./collect-crowd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports